export default __webpack_public_path__ + "static/bncff-web-site-5-57592657ef92d51af63cf3d9ce5261f5.jpg";